import moment from 'moment';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import React from 'react';

import { DISPLAY_DATE_FORMAT_LONG_WITH_DAY } from '../../../config/helpers';
import formatPrice from '../../../util/formatPrice';

import { DEFAULT_CRITICAL_BACKUP_CURRENCY } from '../../../util/currency';
import Icon from '../Atoms/Icon';
import Picture from '../Picture';
import CompareItemButton from '../CompareItemButton';

const propTypes = exact({
  callToBookText: PropTypes.string,
  currencySymbol: PropTypes.string,
  ctaText: PropTypes.string,
  date: PropTypes.string.isRequired,
  description: PropTypes.string,
  fromPriceText: PropTypes.string,
  hasLimitedAvailability: PropTypes.bool.isRequired,
  tourKey: PropTypes.string,
  image: PropTypes.object,
  inclusions: PropTypes.arrayOf(PropTypes.string),
  isCallToBook: PropTypes.bool,
  isSoldOut: PropTypes.bool,
  limitedAvailabilityText: PropTypes.string.isRequired,
  limitedAvailabilityTextOverride: PropTypes.string,
  limitedAvailabilityRemainingSpaces: PropTypes.number,
  price: PropTypes.number.isRequired,
  perPersonText: PropTypes.string,
  soldOutText: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  tournamentName: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  waitingListLink: PropTypes.object,
  waitingListText: PropTypes.string,
  compareCtaText: PropTypes.string.isRequired,
});

const defaultProps = {
  callToBookText: 'Call To Book',
  currencySymbol: DEFAULT_CRITICAL_BACKUP_CURRENCY.symbol,
  ctaText: 'More',
  description: null,
  fromPriceText: 'FROM',
  image: null,
  inclusions: [],
  isCallToBook: false,
  isSoldOut: false,
  limitedAvailabilityRemainingSpaces: null,
  limitedAvailabilityTextOverride: '',
  perPersonText: 'pp',
  tourKey: null,
  waitingListLink: null,
  waitingListText: null,
};

function PromotedPackage(props) {
  return (
    <article className="PromotedItem">
      {props.hasLimitedAvailability && !props.limitedAvailabilityTextOverride && (
        <div className="PromotedItem_limitedAvailability">
          {props.limitedAvailabilityText.replace(
            '{LimitedAvailabilityRemainingSpaces}',
            props.limitedAvailabilityRemainingSpaces
          )}
        </div>
      )}
      {props.hasLimitedAvailability && props.limitedAvailabilityTextOverride && (
        <div className="PromotedItem_limitedAvailability">
          {props.limitedAvailabilityTextOverride.replace(
            '{LimitedAvailabilityRemainingSpaces}',
            props.limitedAvailabilityRemainingSpaces
          )}
        </div>
      )}
      {props.tourKey && (
        <CompareItemButton tourKey={props.tourKey} compareTextLabel={props.compareCtaText} />
      )}
      {props.image && (
        <Picture
          {...props.image}
          className="PromotedItem_image"
          sizes={[
            [100, 1.77], // from 0
            [100, 1.77], // from 480
            [100, 1.77], // from 768
            [100, 1.77], // from 1024
            [100, 1.77], // from 1440
          ]}
        />
      )}
      {!props.image && <div className="PromotedItem_noImage" />}
      <div className="PromotedItem_body">
        <div className="PromotedItem_subtitle">{props.tournamentName}</div>
        <div className="PromotedItem_title">{props.title}</div>
        {props.description && <div className="PromotedItem_description">{props.description}</div>}
        <time className="PromotedItem_date" dateTime={props.date}>
          {moment(props.date).format(DISPLAY_DATE_FORMAT_LONG_WITH_DAY)}
        </time>
      </div>
      <div className="PromotedItem_summary">
        {props.inclusions.length > 0 && (
          <div className="PromotedItem_inclusions">
            <ul className="PromotedItem_inclusionsList">
              {props.inclusions.map((inclusion) => (
                <li key={inclusion} className="PromotedItem_inclusionsItem">
                  <Icon id={inclusion} blockName="PromotedItem_inclusionsIcon" />
                </li>
              ))}
            </ul>
          </div>
        )}
        {props.isSoldOut && props.waitingListLink === null && (
          <div className="PromotedItem_soldOut">{props.soldOutText}</div>
        )}
        {props.waitingListLink != null && (
          <a href={props.url} className="PromotedItem_link PromotedItem_link-waitingList">
            <span className="PromotedItem_soldOutText">{props.soldOutText}</span>
            <span className="PromotedItem_cta">
              <span className="PromotedItem_ctaText">{props.waitingListText}</span>
              <Icon id="arrow-right" blockName="PromotedItem_ctaIcon" />
            </span>
          </a>
        )}
        {!props.isSoldOut && props.waitingListLink === null && (
          <a href={props.url} className="PromotedItem_link">
            <span className="PromotedItem_price">
              {props.fromPriceText} {props.currencySymbol}
              {formatPrice(props.price)}
              {props.perPersonText}
            </span>
            <span className="PromotedItem_cta">
              <span className="PromotedItem_ctaText">
                {props.isCallToBook ? props.callToBookText : props.ctaText}
              </span>
              <Icon id="arrow-right" blockName="PromotedItem_ctaIcon" />
            </span>
          </a>
        )}
      </div>
    </article>
  );
}

PromotedPackage.propTypes = propTypes;
PromotedPackage.defaultProps = defaultProps;

export default PromotedPackage;
